<template>
  <el-dialog
    :visible.sync="dialogVisibless"
    width="25%"
    :before-close="handleClose"
    :append-to-body="true"
    class="dialog-login">

    <div style="display: flex; flex-direction: column; align-items: center;">
      <!-- <p class="user-login">
        <span v-show="!forgetDisplay" class="user-active" :class="!userFlag ? 'user-activeClick' : ''" @click="userFlagClick(false)">个人用户</span>
        <span v-show="!forgetDisplay" class="user-active" :class="userFlag ? 'user-activeClick' : ''" @click="userFlagClick(true)">企业用户</span>
      </p> -->
      <img src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/static/logo/logo.svg" style="width: 200px;"/>
      <div class="phone">
        <p class="phoneHeader">
          <span v-show="!forgetDisplay" class="user-active" :class="codeDisplay ? 'user-activeClick' : ''" @click="codeFlag">验证码登录</span>
          <span v-show="!forgetDisplay" class="user-active" :class="passwordDisplay ? 'user-activeClick' : ''" @click="passwordFlag">密码登录</span>
          <span v-show="forgetDisplay" class="active-forget">忘记密码</span>
        </p>
        <div class="phoneMain">
          <!-- 验证码登录 -->
          <el-form :model="loginCodeForm" ref="loginCodeForm" :rules="dataRule" v-show="codeDisplay">
            
            <el-form-item prop="phoneNo">
                <el-input type="text" autocomplete="on" placeholder="请输入手机号码" v-model="loginCodeForm.phoneNo"/>
            </el-form-item>

            <el-form-item prop="verificationCode">
              <el-input type="text" autocomplete="off" placeholder="请输入短信验证码" v-model="loginCodeForm.verificationCode">
                <template slot="append">
                  <el-button type="button" :disabled="disabledCode" @click="getVerificationCode(loginCodeForm.phoneNo, 1)">
                    <span>{{ btnCode }}</span>
                  </el-button>
                </template>
              </el-input>
            </el-form-item>

            <p class="msg">
              登录即表示已阅读并同意
              <span @click="handleAgreement">《用户协议》</span>
              和
              <span @click="handlePrivacy">《隐私政策》</span>
            </p>

            <el-button type="primary" class="submit-s" :loading="logInNowCodeLoading" @click="logInNowCode">
              <span>登录 / 注册</span>
            </el-button>

          </el-form>

          <!-- 密码登录 -->
          <el-form :model="loginForm" ref="loginForm" :rules="datasRule" v-show="passwordDisplay">
            
            <el-form-item prop="phoneNo">
                <el-input type="text" autocomplete="on" placeholder="请输入手机号码" v-model="loginForm.phoneNo"/>
            </el-form-item>

            <el-form-item prop="password">
              <el-input type="password" autocomplete="off" placeholder="请输入密码" v-model="loginForm.password">
              </el-input>
            </el-form-item>

            <p class="msg">
              登录即表示已阅读并同意
              <span @click="handleAgreement">《用户协议》</span>
              和
              <span @click="handlePrivacy">《隐私政策》</span>
            </p>

            <el-button type="primary" class="submit-s" :loading="logInNowLoading" @click="logInNow">
              <span>立即登录</span>
            </el-button>

            <span class="forget" @click="forget">忘记密码</span>

          </el-form>

          <!-- 忘记密码 -->
          <el-form :model="forgetForm" ref="forgetForm" :rules="forgetRule" v-show="forgetDisplay">
            <el-form-item prop="phoneNo">
                <el-input type="text" autocomplete="on" placeholder="请输入手机号码" v-model="forgetForm.phoneNo"/>
            </el-form-item>

            <el-form-item prop="code">
              <el-input type="text" autocomplete="off" placeholder="请输入短信验证码" v-model="forgetForm.code">
                <template slot="append">
                  <el-button class="btnCode" type="button" :disabled="disabledForget" @click="getVerificationCode(forgetForm.phoneNo, 2)">
                    <span>{{ btnCode }}</span>
                  </el-button>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input type="password" autocomplete="off" placeholder="请输入新密码" v-model="forgetForm.password">
              </el-input>
            </el-form-item>

            <el-button type="primary" class="submit-s" @click="forgetSubmit">
              <span>提交</span>
            </el-button>

          </el-form>

          <div class="existing-account" v-show="forgetDisplay">
            <span class="register" @click="existingAccount">已有账号，马上登录</span>
          </div>

        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getCode, resetPassword } from '@/api/login'
import { mapActions } from 'vuex'
import Cookies from 'js-cookie'

export default {
  name: 'loginPublic',

  props:{
    dialogVisible: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {

      meunNo: 0,

      dialogVisibless: false,
      codeDisplay: false,
      passwordDisplay: false,

      //验证码部分所需的数据
      btnCode: '获取验证码',
      disabledCode: false,
      disabledForget: false,
      time:0,

      //短信验证码登录
      logInNowCodeLoading: false,
      loginCodeForm: {
        //公司名称
        tenantName: '',
        //手机号码
        phoneNo: '',
        //短信验证码
        verificationCode: '',
        //下次自动登录
        automaticLogon: true,
      },
      dataRule: {
        tenantName: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' }
        ],
        phoneNo: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        verificationCode: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' }
        ]
      },

      //密码登录
      logInNowLoading: false,
      loginForm: {
        //公司名称
        tenantName: '',
        //手机号码
        phoneNo: '',
        //密码
        password: '',
        //下次自动登录
        automaticLogon: true,
      },
      datasRule: {
        tenantName: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' }
        ],
        phoneNo: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      },

      //忘记密码
      forgetDisplay: false,
      forgetForm: {
        //手机号码
        mobile: '',
        phoneNo: '',
        //短信验证码
        code: '',
        //密码
        password: '',
      },
      forgetRule: {
        phoneNo: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        code: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      },
    }
  },

  watch:{
    dialogVisible(){
      this.dialogVisibless = this.dialogVisible;
      if (!this.dialogVisibless) {
        this.codeDisplay = true;
      }
    },

    loginCodeForm() {
      this.$refs.loginCodeForm.resetFields();   // 表单重置
    },
    loginForm() {
      this.$refs.loginForm.resetFields();   // 表单重置
    },
    forgetForm() {
      this.$refs.forgetForm.resetFields();   // 表单重置
    },

    loginCodeForm: {
      handler(newValue, oldValue) {
        if (/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(newValue.phoneNo)) {
          this.disabledCode = false;
        }
      },
        deep: true
    },

    forgetForm: {
      handler(newValue, oldValue) {
        if (/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(newValue.phoneNo)) {
          this.disabledForget = false;
        }
      },
        deep: true
    }

  },

  mounted() {
    this.codeDisplay = true;
    if (!this.loginCodeForm.phoneNo) {
      this.disabledCode = true;
    }
  },

  methods: {
    ...mapActions([
      'Login',
      'LoginCode',
      'GetInfo'
    ]),

    //关闭弹窗
    handleClose() {
      this.dialogVisibless = false;
      this.codeDisplay = false;
      this.passwordDisplay = false;
      this.forgetDisplay = false;
      this.clean();
      this.$emit('handleClose')
    },


    //短信验证码登录
    codeFlag() {
      this.codeDisplay = true;
      this.passwordDisplay = false;
      this.logInNowCodeLoading = false;
      this.clean();
    },

    //密码登录
    passwordFlag() {
      this.codeDisplay = false;
      this.passwordDisplay = true;
      this.logInNowLoading = false;
      this.clean();
    },

    //清空
    clean() {
      this.loginCodeForm = {
        //公司名称
        tenantName: '',
        //手机号码
        phoneNo: '',
        //短信验证码
        verificationCode: '',
        //下次自动登录
        automaticLogon: true
      };
      this.loginForm = {
        //公司名称
        tenantName: '',
        //手机号码
        phoneNo: '',
        //密码
        password: '',
        //下次自动登录
        automaticLogon: true
      };
      this.forgetForm = {
        //手机号码
        mobile: '',
        phoneNo: '',
        //短信验证码
        code: '',
        //密码
        password: ''
      };
      this.disabledCode = true;
      this.disabledForget = true;
    },

    //获取手机验证码方法
    getVerificationCode(phoneNo, num){
      //发送axios请求 获取验证码
      this.time = 60;   //设置倒计时的时间（单位：秒）
      this.meunNo = num;
      if(this.meunNo == 1) {
        this.disabledCode = true;
      } else if (this.meunNo == 2) {
        this.disabledForget = true;
      }
      this.timer(this.meunNo);     //调用倒计时方法

      getCode(phoneNo, this.loginCodeForm.tenantName).then((res) => {
        if (res.code == 0){
          //短信验证码发送成功时的消息提示
          this.$message({
            message: '验证码发送成功',
            type: 'success',
          });
        }else {
          //短信验证码发送失败时的消息提示
          this.$message({
            message: '验证码发送失败',
            type: 'warning',
          });
        }
      })
    },

    //倒计时方法
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btnCode = this.time+ "s后再试";
        setTimeout(this.timer, 1000);
      } else{
        this.time = 0;
        this.btnCode = "获取验证码";
        if(this.meunNo == 1) {
          this.disabledCode = false;
        } else if (this.meunNo == 2) {
          this.disabledForget = false;
        }
      }
    },

    //验证码登录
    logInNowCode() {
      this.logInNowCodeLoading = true;
      this.$refs.loginCodeForm.validate((valid) => {
        if (valid) {
          this.LoginCode(this.loginCodeForm)
            .then((res) => {
              this.getInfo()
              let that = this;
              that.$nextTick(() => {
                that.$router.push({
                    path: "/index"
                })
              })
              // setTimeout(() => {
                this.logInNowCodeLoading = false;
                // 刷新页面
                location.reload();
              // }, 500);
            })
            .catch(() => {
              this.logInNowCodeLoading = false;
            });
        } else {
          this.logInNowCodeLoading = false;
          return false;
        }
      });
    },

    //密码登录
    logInNow() {
      this.logInNowLoading = true;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.Login(this.loginForm)
            .then((res) => {
              this.getInfo()
              let that = this;
              that.$nextTick(() => {
                that.$router.push({
                    path: "/index"
                })
              })
              // setTimeout(() => {
                this.logInNowLoading = false;
                // 刷新页面
                location.reload();
              // }, 500);
            })
            .catch(() => {
              this.logInNowLoading = false;
            });
        } else {
          this.logInNowLoading = false;
          return false;
        }
      });
    },

    //忘记密码
    forget() {
      this.forgetDisplay = true;
      this.codeDisplay = false;
      this.passwordDisplay = false;
      this.clean();
    },

    //忘记密码提交
    forgetSubmit() {
      this.$refs.forgetForm.validate((valid) => {
        if (valid) {
          this.forgetForm.mobile = this.forgetForm.phoneNo;
          resetPassword(this.forgetForm).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: '密码重置成功',
                type: 'success',
              })
              setTimeout(() => {
                // 刷新页面
                location.reload();
              }, 500);
            }
          })
        } else {
          return false;
        }
      });
    },

    //已有账户，马上登录
    existingAccount() {
      this.passwordDisplay = true;
      this.forgetDisplay = false;
      this.codeDisplay = false;
      this.clean();
    },

    //立即注册
    register() {
      this.dialogVisibless = false;
      this.passwordDisplay = false;
      this.forgetDisplay = false;
      this.codeDisplay = false;
      this.clean();
      this.$emit('handleClose')
      let that = this;
      that.$nextTick(() => {
        that.$router.push({
            path: "/register"
        })
      })
    },

    //获取用户信息
    getInfo() {
      this.GetInfo()
          .then((res) => {
          })
          .catch(() => {
        })
    },
    handleAgreement() {
      const url = this.$router.resolve({ path: '/agreement' }).href;
      window.open(url, '_blank');
    },
    handlePrivacy() {
      const url = this.$router.resolve({ path: '/privacy' }).href;
      window.open(url, '_blank');
    },
  }
}
</script>

<style  lang="less">

  .dialog-login {
    height: 100%;
    overflow: hidden;
  }

  .dialog-login .el-dialog {
    height: 50%;
    min-height: 438px;
    min-width: 550px;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 40px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
      height: 100%;
    }
  }

  /deep/.el-dialog__body {
    height: 70vh;overflow: auto;
  }


  .user-login {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
  }

  .user-active {
    font-size: 21px;
    font-weight: 500;
    color: #888A8D;
    cursor: pointer;
  }

  .user-active:hover {
    color: #888A8D;
  }

  .user-activeClick {
    font-weight: 800;
    color: #1557fc;
  }

  .user-activeClick:hover {
    color: #2f5fd8;
  }

  .phone {
    margin: 0 auto;
    width: 395px;
  }

  .phoneHeader {
    display: flex;
    justify-content: space-around;
    padding: 25px 20px 5px;
  }

  .phoneMain {
    height: 300px;
  }

  .phone .el-input__inner {
    height: 45px;
  }

  .el-form-item .el-form-item__content .el-input .el-input-group__append .el-button {
    background: #f5f5f5;
    border: none;
    color: #346cf4;
    height: 45px;
    width: 110px;
  }

  .active-forget {
    color: #1557fc;
    font-size: 21px;
    font-weight: 500;
  }

  .forget {
    margin-top: 20px;
    float: right;
    color: #888A8D;
    cursor: pointer;
  }

  .forget:hover {
    color: #2f5fd8;
  }

  .el-button.submit-s {
    margin-top: 10px;
    color: white;
    background: linear-gradient(44deg,#346cf4,#539fff);;
    width: 100%;
    border-radius: 4px;
    border-width: 0;
    cursor: pointer;
    font-size: 16px;
    height: 49px;
    width: 100%;
  }

  .el-button.submit-s.el-button--primary:hover {
    // background-color: #346cf4;
    border-color: #346cf4;
    background: linear-gradient(44deg, #346cf4, #539fff);
  }

  .register {
    color: #346cf4;
    cursor: pointer;
  }

  .register:hover {
    color: #6489e6;
  }

  .existing-account {
    margin-top: 20px;
    margin-left: 30%;
  }


  .msg {
    color: #9090a3;
    font-size: 12px;
    text-align: center;
    span {
      color: #346cf4;
      cursor: pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/login-public.vue